export default "__VITE_ASSET__BXOHA2AO__"